import type { ApiError } from '@shared/types/error-response';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

/**
 * Type predicate to narrow an unknown error to `FetchBaseQueryError`
 */
export function isFetchBaseQueryError(error: unknown): error is FetchBaseQueryError {
  return typeof error === 'object' && error != null && 'status' in error;
}

/**
 * Type predicate for the backend error format (`{ status, code, message }`)
 */
export function isApiError(data: unknown): data is ApiError {
  return typeof data === 'object' && data !== null && typeof (data as ApiError).message === 'string';
}

export function getApiErrorMessage(error: unknown): string {
  if (isFetchBaseQueryError(error)) {
    if (isApiError(error.data)) {
      return error.data.message;
    }

    return typeof error.status === 'number'
      ? `Erreur ${error.status}: ${JSON.stringify(error.data)}`
      : `Erreur : ${error.status}`;
  }

  return 'Une erreur inconnue est survenue.';
}
